var _effectorFileName = "/builds/gmini/front-ui-kit/src/PageTitle/PageTitle.tsx";
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { createGate, useStore } from 'effector-react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const PageTitleOptions = createGate({
  defaultState: {}
});
export const PageTitle = /*#__PURE__*/React.memo(({ ...props
}) => {
  const {
    siteName,
    delimiter = '|'
  } = useStore(PageTitleOptions.state, {
    loc: {
      file: _effectorFileName,
      line: 15,
      column: 40
    },
    name: "PageTitle",
    sid: "PageTitle /src/PageTitle/PageTitle.tsx [15, 40]"
  });
  const children = React.Children.toArray(props.children).join('');
  const title = siteName ? `${children} ${delimiter} ${siteName}` : props.children;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Helmet, {
      children: /*#__PURE__*/_jsx("title", {
        children: title
      })
    })
  });
});
PageTitle.displayName = 'PageTitle';